import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ServiceRequestedChange } from './service-requested-change.model';
import * as ServiceRequestedChangeActions from './service-requested-change.actions';

export const serviceRequestedChangesFeatureKey = 'serviceRequestedChanges';

export interface State extends EntityState<ServiceRequestedChange> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceRequestedChange> = createEntityAdapter<ServiceRequestedChange>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceRequestedChangeActions.addServiceRequestedChange,
    (state, action) => adapter.addOne(action.serviceRequestedChange, state)
  ),
  on(ServiceRequestedChangeActions.upsertServiceRequestedChange,
    (state, action) => adapter.upsertOne(action.serviceRequestedChange, state)
  ),
  on(ServiceRequestedChangeActions.addServiceRequestedChanges,
    (state, action) => adapter.addMany(action.serviceRequestedChanges, state)
  ),
  on(ServiceRequestedChangeActions.upsertServiceRequestedChanges,
    (state, action) => adapter.upsertMany(action.serviceRequestedChanges, state)
  ),
  on(ServiceRequestedChangeActions.updateServiceRequestedChange,
    (state, action) => adapter.updateOne(action.serviceRequestedChange, state)
  ),
  on(ServiceRequestedChangeActions.updateServiceRequestedChanges,
    (state, action) => adapter.updateMany(action.serviceRequestedChanges, state)
  ),
  on(ServiceRequestedChangeActions.deleteServiceRequestedChange,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceRequestedChangeActions.deleteServiceRequestedChanges,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceRequestedChangeActions.loadServiceRequestedChanges,
    (state, action) => adapter.setAll(action.serviceRequestedChanges, state)
  ),
  on(ServiceRequestedChangeActions.clearServiceRequestedChanges,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
